export default __webpack_public_path__ + "static/media/button_b.7200d285.png";